import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { MessageBar } from 'office-ui-fabric-react/lib/MessageBar';
import clsx from 'clsx';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { useStatementRejection } from '../../context/statement-rejection';
import styles from './StatementRegenerateDialog.style';

const StatementRegenerateDialog = ({ onDismiss, onSubmit, className, ...other }) => {
  const { message, setRejectionMessage } = useStatementRejection();
  const [validationMessage, setValidationMessage] = useState();

  const handleInputChange = e => {
    setValidationMessage('');
    setRejectionMessage(e.target.value);
  };

  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        title: 'Regenerate Statement',
        subText:
          'Describe what updates were applied to the contract that require statement regeneration.',
        closeButtonAriaLabel: 'Close',
      }}
      modalProps={{
        className: clsx(styles.root, className),
      }}
      onDismiss={onDismiss}
      onSubmit={onSubmit}
      {...other}
    >
      <TextField
        name="message"
        label="What contract updates were made?"
        placeholder="Comments will only be visible to RCO team members"
        multiline
        resizable={false}
        value={message}
        onChange={handleInputChange}
        required
        errorMessage={validationMessage}
      />
      <MessageBar
        messageBarIconProps={{ iconName: 'Info' }}
        isMultiline
        className={styles.textFieldMessage}
        nowrap
      >
        Statement regeneration could take several minutes. You will be notified when the regenerated
        statement is available for reveiw.
      </MessageBar>
      <DialogFooter>
        <DefaultButton
          onClick={() => {
            setValidationMessage('');
            onDismiss();
          }}
        >
          Cancel
        </DefaultButton>
        <PrimaryButton
          type="submit"
          onClick={() => {
            if (message === '') {
              setValidationMessage('Required');
              return;
            }
            onSubmit();
          }}
        >
          Regenerate
        </PrimaryButton>
      </DialogFooter>
    </Dialog>
  );
};

StatementRegenerateDialog.propTypes = {
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
};

StatementRegenerateDialog.defaultProps = {
  className: 'normal',
  onDismiss: null,
  onSubmit: null,
};

export default StatementRegenerateDialog;
